<template>
  <section class="work">
    <h1 class="title"><span>Work</span></h1>
    <Gallery :items="works" />
  </section>
</template>

<script>
import anime from 'animejs';
import Gallery from '../components/Gallery.vue';
export default {
  name: 'Work',
  components: {
    Gallery
  },
  computed: {
    works() {
      return this.$store.state.works;
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.work {
  max-width: 1240px;

  span {
    display: inline-block;
  }

  @include mq(0, 768px) {}
}
</style>



// WEBPACK FOOTER //
// src/containers/Work.vue